import { v4 as uuidv4 } from 'uuid';

export function DisclosureStateIndicator(props = {}) {
	return {
		componentName: 'DisclosureStateIndicator',
		componentId: uuidv4(),
		props: Object.assign(
			{
				Show: '',
				Hide: '',
			},
			props,
		),
		childrenComponents: [],
	};
}
